/* Live Free — header (BUILD-03). No dependencies, one delegated listener per
   behaviour. Everything works without this file: triggers are links or plain
   buttons, the drawer is a <details>, search submits to /search. This adds:
   hover/click megas with Escape, the live free + glossary chevrons, one Files
   accordion open at a time, scroll condense (rAF-throttled, flips one class),
   the mobile drawer with sliding panels and a focus trap, predictive search. */
(function () {
  'use strict';
  var hdr = document.querySelector('[data-lf-header]');
  if (!hdr) return;
  document.documentElement.classList.add('lf-hdr-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desk = window.matchMedia('(min-width: 900px)');

  /* ---- megas + dropdowns ---- */
  var openKey = null, hoverTimer = null, lastTrigger = null;
  function trigger(key) { return hdr.querySelector('[data-lf-trigger="' + key + '"]'); }
  function layer(key) { return hdr.querySelector('[data-lf-mega="' + key + '"]'); }
  function closeMenu() {
    if (!openKey) return;
    var t = trigger(openKey), l = layer(openKey);
    if (t) t.setAttribute('aria-expanded', 'false');
    if (l) l.hidden = true;
    openKey = null;
  }
  function openMenu(key) {
    if (openKey === key) return;
    closeMenu(); closeSearch(false);
    var t = trigger(key), l = layer(key);
    if (!t || !l) return;
    t.setAttribute('aria-expanded', 'true');
    l.hidden = false;
    openKey = key;
  }
  hdr.addEventListener('click', function (e) {
    var t = e.target.closest('[data-lf-trigger]');
    if (t) { e.preventDefault(); lastTrigger = t; if (openKey === t.dataset.lfTrigger) closeMenu(); else openMenu(t.dataset.lfTrigger); }
  });
  hdr.addEventListener('mouseover', function (e) {
    if (!desk.matches) return;
    var item = e.target.closest('[data-lf-item]');
    var l = e.target.closest('[data-lf-mega]');
    clearTimeout(hoverTimer);
    if (item) { var k = item.dataset.lfItem; hoverTimer = setTimeout(function () { openMenu(k); }, 60); }
    else if (l) { /* stay open */ }
  });
  hdr.addEventListener('mouseleave', function () { if (desk.matches) { clearTimeout(hoverTimer); hoverTimer = setTimeout(closeMenu, 160); } });
  hdr.addEventListener('mouseover', function (e) {
    if (!desk.matches || !openKey) return;
    if (!e.target.closest('[data-lf-item="' + openKey + '"], [data-lf-mega="' + openKey + '"]')) {
      clearTimeout(hoverTimer); hoverTimer = setTimeout(function () { if (openKey && !hdr.querySelector('[data-lf-mega="' + openKey + '"]:hover, [data-lf-item="' + openKey + '"]:hover')) closeMenu(); }, 220);
    }
  });
  document.addEventListener('click', function (e) { if (openKey && !hdr.contains(e.target)) closeMenu(); });
  hdr.addEventListener('focusout', function (e) {
    if (!openKey) return;
    var next = e.relatedTarget;
    if (next && !hdr.contains(next)) closeMenu();
  });

  /* ---- Files accordions: one open at a time ---- */
  hdr.addEventListener('click', function (e) {
    var btn = e.target.closest('.lf-acc__btn');
    if (!btn) return;
    var acc = btn.closest('[data-lf-acc]'), group = btn.closest('[data-lf-accs]');
    var wasOpen = acc.classList.contains('is-open');
    group.querySelectorAll('[data-lf-acc]').forEach(function (a) {
      a.classList.remove('is-open');
      a.querySelector('.lf-acc__btn').setAttribute('aria-expanded', 'false');
      a.querySelector('.lf-acc__body').hidden = true;
    });
    if (!wasOpen) { acc.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); acc.querySelector('.lf-acc__body').hidden = false; }
  });

  /* ---- scroll condense ---- */
  var condensed = false, ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var should = window.scrollY > 24;
      if (should !== condensed) { condensed = should; hdr.classList.toggle('is-condensed', condensed); }
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---- predictive search ---- */
  var form = hdr.querySelector('[data-lf-search]');
  var panel = hdr.querySelector('[data-lf-search-panel]');
  var sheet = hdr.querySelector('[data-lf-msearch]');
  var searchTimer = null, searchCtl = null;
  function money(cents) { return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) : '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
  function renderResults(root, data) {
    var res = root.querySelector('[data-lf-results]');
    if (!res) return;
    var any = false;
    var map = { products: 'products', collections: 'collections', articles: 'articles' };
    Object.keys(map).forEach(function (k) {
      var col = res.querySelector('[data-lf-results-col="' + k + '"]');
      var list = col.querySelector('[data-lf-results-list]');
      var items = (data && data.resources && data.resources.results && data.resources.results[k]) || [];
      list.innerHTML = '';
      items.slice(0, 4).forEach(function (it) {
        var a = document.createElement('a');
        a.className = 'lf-sresults__row'; a.href = it.url;
        var name = document.createElement('span'); name.textContent = k === 'products' ? String(it.title).split(/\s[\u2013\u2014]\s|\s-\s/)[0] : it.title; a.appendChild(name);
        if (k === 'products' && it.price != null) { var m = document.createElement('span'); m.className = 'lf-sresults__meta'; m.textContent = money(parseFloat(it.price) * 100); a.appendChild(m); }
        list.appendChild(a);
      });
      col.hidden = items.length === 0;
      if (items.length) any = true;
    });
    res.querySelector('[data-lf-results-none]').hidden = any;
    res.hidden = false;
  }
  function suggest(q, root) {
    if (searchCtl) searchCtl.abort();
    if (!q || q.length < 2) { var r = root.querySelector('[data-lf-results]'); if (r) r.hidden = true; return; }
    searchCtl = window.AbortController ? new AbortController() : null;
    var url = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,article&resources[limit]=4&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,vendor,body,tag';
    fetch(url, { signal: searchCtl && searchCtl.signal, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d) renderResults(root, d); })
      .catch(function () {});
  }
  function openSearch() {
    closeMenu();
    if (desk.matches) {
      if (!form) return;
      form.classList.add('is-open');
      form.querySelector('[data-lf-search-close]').hidden = false;
      if (panel) panel.hidden = false;
    } else {
      if (!sheet) return;
      closeDrawer();
      sheet.hidden = false; document.body.classList.add('lf-hdr-lock');
      var inp = sheet.querySelector('[data-lf-search-input]'); if (inp) inp.focus();
    }
  }
  function closeSearch(refocus) {
    if (form) { form.classList.remove('is-open'); var c = form.querySelector('[data-lf-search-close]'); if (c) c.hidden = true; }
    if (panel) panel.hidden = true;
    if (sheet && !sheet.hidden) { sheet.hidden = true; document.body.classList.remove('lf-hdr-lock'); if (refocus) { var b = hdr.querySelector('[data-lf-search-open]'); if (b) b.focus(); } }
  }
  hdr.addEventListener('focusin', function (e) { if (e.target.matches('[data-lf-search] [data-lf-search-input]')) openSearch(); });
  hdr.addEventListener('click', function (e) {
    if (e.target.closest('[data-lf-search-open]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-lf-search-close]')) { e.preventDefault(); closeSearch(true); }
  });
  hdr.addEventListener('input', function (e) {
    var inp = e.target.closest('[data-lf-search-input]');
    if (!inp) return;
    var root = inp.closest('[data-lf-msearch]') || panel;
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () { suggest(inp.value.trim(), root); }, 180);
  });
  document.addEventListener('click', function (e) { if (form && form.classList.contains('is-open') && !hdr.contains(e.target)) closeSearch(false); });

  /* ---- mobile drawer ---- */
  var drawer = hdr.querySelector('[data-lf-drawer]');
  var stack = ['root'];
  var rootLabel = drawer ? drawer.querySelector('[data-lf-back-label]').textContent : '';
  function panelEl(name) { return drawer.querySelector('[data-lf-panel="' + name + '"]'); }
  function showPanel(name, animate) {
    var cur = drawer.querySelector('[data-lf-panel]:not([hidden])');
    var next = panelEl(name);
    if (!next) return;
    if (cur) cur.hidden = true;
    next.hidden = false;
    next.classList.toggle('lf-dpanel--in', !!animate && !reduce);
    var atRoot = name === 'root';
    drawer.querySelector('[data-lf-at-root]').hidden = !atRoot;
    var back = drawer.querySelector('[data-lf-back]');
    back.hidden = atRoot;
    if (!atRoot) back.querySelector('[data-lf-back-label]').textContent = next.dataset.lfBack || rootLabel;
    var scroll = drawer.querySelector('[data-lf-drawer-scroll]'); if (scroll) scroll.scrollTop = 0;
    var focusable = next.querySelector('button, a, input'); if (focusable && animate) focusable.focus({ preventScroll: true });
  }
  function openDrawer() {
    if (!drawer) return;
    closeSearch(false); closeMenu();
    drawer.open = true;
    document.body.classList.add('lf-hdr-lock');
    stack = ['root']; showPanel('root', false);
    var c = drawer.querySelector('[data-lf-drawer-close]'); if (c) c.focus({ preventScroll: true });
  }
  function closeDrawer() {
    if (!drawer || !drawer.open) return;
    drawer.open = false;
    document.body.classList.remove('lf-hdr-lock');
    var b = drawer.querySelector('[data-lf-burger]'); if (b) b.focus({ preventScroll: true });
  }
  if (drawer) {
    drawer.querySelector('[data-lf-burger]').addEventListener('click', function (e) { e.preventDefault(); if (drawer.open) closeDrawer(); else openDrawer(); });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-lf-drawer-close]')) { closeDrawer(); return; }
      var open = e.target.closest('[data-lf-open-panel]');
      if (open) { stack.push(open.dataset.lfOpenPanel); showPanel(open.dataset.lfOpenPanel, true); return; }
      var cat = e.target.closest('[data-lf-open-cat]');
      if (cat) { stack.push('cat-' + cat.dataset.lfOpenCat); showPanel('cat-' + cat.dataset.lfOpenCat, true); return; }
      if (e.target.closest('[data-lf-back]')) {
        stack.pop();
        var prev = stack[stack.length - 1] || 'root';
        showPanel(prev, false);
      }
    });
    // focus trap
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !drawer.open) return;
      var box = drawer.querySelector('[data-lf-drawer-box]');
      var f = Array.prototype.filter.call(box.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    desk.addEventListener && desk.addEventListener('change', function (m) { if (m.matches) { closeDrawer(); closeSearch(false); } else closeMenu(); });
  }

  /* ---- Escape closes any layer, focus returns ---- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.open) { closeDrawer(); return; }
    if (sheet && !sheet.hidden) { closeSearch(true); return; }
    if (form && form.classList.contains('is-open')) { closeSearch(false); form.querySelector('[data-lf-search-input]').blur(); return; }
    if (openKey) { var t = trigger(openKey); closeMenu(); if (t) t.focus(); }
  });
})();